import React from 'react';
import SeriesItem from './SeriesItem';

class Series extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      series: props.series.map((s, i) => {
        return (
          <SeriesItem
            key={i}
            id={s.get('id')}
            image={s.get('cover')}
            title={s.get('title')}
          />
        );
      })
    };
  }

  render() {
    return this.state.series.length > 0 ? (
      <span>
        <h3>Series</h3>
        <div>{this.state.series}</div>
      </span>
    ) : null;
  }
}

export default Series;
